import { CSSObject } from '@emotion/react'

type SharedStyleProps = (
  height: number,
  width: number,
  asset: {
    height: number
    width: number
  },
  isDragging?: boolean,
  isHidden?: boolean
) => CSSObject

const getImgStyling: SharedStyleProps = (height, width, asset) => ({
  cursor: 'grab',
  height: `calc(${height}px * ${asset.height})`,
  margin: '1px',
  width: `calc(${width}px * ${asset.width})`,
})

const getDragAreaStyling: SharedStyleProps = (
  height,
  width,
  asset,
  isDragging,
  isHidden
) => ({
  background: isHidden ? 'white' : 'unset',
  cursor: 'grab',
  height: `calc(${height}px * ${asset.height})`,
  position: 'absolute',
  width: `calc(${width}px * ${asset.width})`,
  zIndex: isDragging ? 1 : 0,
})

const styles = {
  getImgStyling,
  getDragAreaStyling,
}

export { styles }
